import React from "react";
import GoogleMapReact from 'google-map-react';
import MarcadorComponent from "./MarcadorComponent";
import { Fragment } from 'react';


export default function MapaComponent(props) {

  const puntos = props.puntos

      const [mostrarVentanita, setMostrarVentanita] = React.useState(false);

    const handleMostrarVentanita = () => {
        setMostrarVentanita(true);
    }

    const handleCerrarVentanita = () => {
        setMostrarVentanita(false);

    }


  const defaultProps = {
    centro: {
      lat:parseInt(props.lat),
      lng:parseInt(props.lng)
    },
    zoom: props.zoom
  };
  const handleApiLoaded = (map, maps) => {
    // use map and maps objects
  };

  return (
    <Fragment>
     
          <div style={{ height: '100vh', width: '100%' }}>
            <GoogleMapReact
              bootstrapURLKeys={{ key: "AIzaSyAcjbOJJFtJYTp5K2YYxzrghuztGXhWnOw" }}
              defaultCenter={defaultProps.centro}
              defaultZoom={defaultProps.zoom}
              yesIWantToUseGoogleMapApiInternals
              onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
            >
              {
                puntos.map((punto, index) => (
                  <MarcadorComponent key={index} punto={punto} lng={punto.lng} lat={punto.lat}></MarcadorComponent>
                ))
              }
            </GoogleMapReact>
          </div>
        
       
    </Fragment>
  );
}